import {
  checkPhone,

} from "@/components/FormCustom/rule";

export const tableFormConfig = [
  {
    mold: "input",
    prop: "kw",
    name: "",
    placeholder: "搜索姓名/注册手机",
  },
  {
    mold: "querybutton",
    name: "搜索",
  },
];

export const columns = [
  {
    label: "姓名",
    prop: "recruit_name",
  },
  {
    label: "注册手机",
    prop: "mobile",
  },
  {
    label: "职位",
    prop: "post",
  }  
];
export const formConfig = [
  [
    {
      mold: "input",
      name: "注册手机",
      prop: "mobile",
      placeholder: "请填写",
      maxlength: 11,
      style:{
        width:"278px"
      },
    },
    {
      mold: "input",
      name: "姓名",
      prop: "name",
      placeholder: "请填写",
      maxlength: 10,
      style:{
        width:"278px"
      },
    },
    {
      mold: "input",
      name: "职位",
      prop: "post",
      placeholder: "请填写",
      maxlength: 10,
      style:{
        width:"278px"
      },
    },
  ],
];

export const rules = {
  mobile: [
    { required: true, message: "请填写正确的手机号", trigger: "blur" },
    { validator: checkPhone, message: "请填写正确的手机号", trigger: "blur" },
  ],
  name: [
    { required: true, message: "请填写正确的姓名（2~10位）", trigger: "blur" },
    { min: 2, max: 10, message: '请填写正确的姓名（2~10位）', trigger: 'blur' }
  ],
  post: [{ required: true, message: "请填写职位", trigger: "blur" }],
};

export const deliverFormConfig = (options) => {
  return [
    [
      {
        mold: "select",
        name: "",
        prop: "id",
        placeholder: "请选择",
        multiple: false,
        emptyEnable: false,
        searchEnable: true,
        options: options,
        style:{
          width:"180px"
        },
      },
    ],
  ];
};
export const deliverRules = {
  id: [
    {
      required: true,
      message: "请选择要转交为新管理员的成员",
      trigger: "change",
    },
  ],
};

export const distributionFormConfig = (data,distributionFormData = null) => {
  return [
    [
      {
        mold: "input",
        prop: "idnumber",
        maxlength: 8,
        class: "distribution-form-input",
        name: "姓名",
        // label: `职位置顶点<span>（可分配：${data.surplus.post_top_point_surplus+data.quota.post_top_point}）</span>`,
        placeholder: "请输入要分配的数量",
        default: data.quota.post_top_point,
        // width:180,
        // link: {
        //   mold: "radio",
        //   prop: "id",
        //   default: distributionFormData ? distributionFormData.id : 1,
        //   position: "after",
        //   options: [
        //     {
        //       label: "剩余全部",
        //       value: 1,
        //     },
        //     {
        //       label: "固定分配",
        //       value: 2,
        //     },
        //   ],
        //   async handler(val) {
            
        //     return {
        //       disabled: val === 1,
        //       default:
        //         val === 2 && distributionFormData ? distributionFormData.idnumber : null,
        //     };
        //   },
        // },
      },
      {
        mold: "input",
        prop: "idnumber1",
        maxlength: 8,
        class: "distribution-form-input",
        label: `职位刷新点<span>（可分配：${data.surplus.post_refresh_point_surplus + data.quota.post_refresh_point}）</span>`,
        // style: {
        //   width: "180px",
        // },
        placeholder: "请输入要分配的数量",
        default: data.quota.post_refresh_point,
        // width:180,
        // link: {
        //   mold: "input",
        //   prop: "id1",
        //   default: distributionFormData ? distributionFormData.id1 : 1,
        //   position: "after",
        //   // options: [
        //   //   {
        //   //     label: "剩余全部",
        //   //     value: 1,
        //   //   },
        //   //   {
        //   //     label: "固定分配",
        //   //     value: 2,
        //   //   },
        //   // ],
        //   // async handler(val) {
        //   //   return {
        //   //     disabled: val === 1,
        //   //     default:
        //   //       val === 2 && distributionFormData ? distributionFormData.idnumber1 : null,
        //   //   };
        //   // },
        // },
      },
      {
        mold: "input",
        prop: "idnumber2",
        maxlength: 8,
        class: "distribution-form-input",
        label: `职位省心推<span>（可分配：${data.surplus.post_push_point_surplus+data.quota.post_push_point}）</span>`,
        // style: {
        //   width: "180px",
        // },
        // width:180,
        placeholder: "请输入要分配的数量",
        default: data.quota.post_push_point,
        // link: {
        //   mold: "radio",
        //   prop: "id3",
        //   default: distributionFormData ? distributionFormData.id3 : 1,
        //   position: "after",
        //   options: [
        //     {
        //       label: "剩余全部",
        //       value: 1,
        //     },
        //     {
        //       label: "固定分配",
        //       value: 2,
        //     },
        //   ],
        //   async handler(val) {
        //     return {
        //       disabled: val === 1,
        //       default:
        //         val === 2 && distributionFormData ? distributionFormData.idnumber3 : null,
        //     };
        //   },
        // },
      },
      {
        mold: "input",
        prop: "idnumber3",
        maxlength: 8,
        class: "distribution-form-input",
        label: `简历下载点<span>（可分配：${data.surplus.resume_download_num_surplus+data.quota.resume_download_num}）</span>`,
        // style: {
        //   width: "180px",
        // },
        // width:180,
        placeholder: "请输入要分配的数量",
        default: data.quota.resume_download_num,
        // link: {
        //   mold: "radio",
        //   prop: "id2",
        //   default: distributionFormData ? distributionFormData.id2 : 1,
        //   position: "after",
        //   options: [
        //     {
        //       label: "剩余全部",
        //       value: 1,
        //     },
        //     {
        //       label: "固定分配",
        //       value: 2,
        //     },
        //   ],
        //   async handler(val) {
        //     return {
        //       disabled: val === 1,
        //       default:
        //         val === 2 && distributionFormData ? distributionFormData.idnumber2 : null,
        //     };
        //   },
        // },
      },
      
    ],
  ];
};
export const distributionRules = {
  // idnumber: [
  //   {
  //     validator: checkDecimal(9),
  //     message: "请填写正确职位发布数的分配数量",
  //     trigger: "blur",
  //   },
  //   { validator: checkInteger, message: "请填写正确职位发布数的分配数量", trigger: "blur" },
  // ],
};

export const api = "/recruitment/company/employer_intact_list";
